import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import "./rolesset.css";
import { faAngleRight, faChevronLeft, faChevronRight, faFilter, faFilterCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdminRoletabs from '../../components/common/AdminRoletabs';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../services/apiService';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
// import Select from 'react-select';
// import { useNavigate } from 'react-router-dom';
import { MenuItem, TextField } from '@mui/material';
import { Modal } from 'react-bootstrap';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
function UserAuditHistory() {
    const navigate = useNavigate();
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [modalData, setModalData] = useState(null);
    
    const handleClose3 = () => setShow(false);
    
    const handleShow = (data) => {
        setModalData(data);
        setShow(true);
    };
    const fetchMembers = useCallback(async () => {
        setLoading(true);
        try {
        const response = await apiService.getRequest('/audit-history');
        if(response.success === true){
            setMembers(response.data);
        }
        } catch (error) {
            console.error('Error fetching list:', error);
        }finally{
        setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchMembers();
    }, [fetchMembers]);
    const [isGridVisible, setGridVisible] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    // const handleShow = () => setShow(true);

    
    const toggleGrid = () => {
        setGridVisible((prev) => !prev);
    };

    const [filters, setFilters] = useState([{ operator: 'And', column: 'updatedBy', operatorType: 'contains', value: '' }]);


    const combineOptions = [
        { value: 'And', label: 'And' },
        { value: 'Or', label: 'Or' },
    ];

    const rows = members.map((datas, index) => ({
        index: index + 1,
        id: datas.id,
        updatedBy: datas.actor,
        reference: datas.reference,
        Module: datas.model,
        date: datas.date,
        action: datas.action,
        Changes: datas.changes,
        description: datas.description || "No Activity",
    }));

    const handleFilterChange = (index, field, value) => {
        const newFilters = [...filters];
        // Reset value if changing the column type
        if (field === 'column') {
            newFilters[index].value = newFilters[index].column === 'date' ? [null, null] : '';
        }
        newFilters[index][field] = value;
        setFilters(newFilters);
    };

    const addFilter = () => {
        setFilters([...filters, { operator: 'And', column: 'updatedBy', operatorType: 'contains', value: '' }]);
    };

    const removeFilter = (index) => {
        setFilters(filters.filter((_, i) => i !== index));
    };
    const operatorOptions = [
        { value: 'contains', label: 'contains' },
        { value: 'doesNotContain', label: 'does not contain' },
        { value: 'startsWith', label: 'starts with' },
        { value: 'endsWith', label: 'ends with' },
        { value: 'is', label: 'is' },
        { value: 'isNot', label: 'is not' },
        { value: 'isEmpty', label: 'is empty' },
        { value: 'isNotEmpty', label: 'is not empty' },
    ];
    const getOperatorOptions = (column) => {
        if (column === 'date') {
            return [
                { value: 'on', label: 'On' },
                { value: 'notOn', label: 'Not On' },
                { value: 'before', label: 'Before' },
                { value: 'atOrBefore', label: 'At Or Before' },
                { value: 'after', label: 'After' },
                { value: 'atOrAfter', label: 'At Or After' },
                { value: 'between', label: 'Between' },
                { value: 'isEmpty', label: 'is empty' },
                { value: 'isNotEmpty', label: 'is not empty' },
            ];
        }
        return operatorOptions; // Default options
    };
    
    const filteredRows = rows.filter((row) =>
        filters.reduce((acc, filter, index) => {
            const rowValue = row[filter.column] ? row[filter.column].toString() : '';
            let matches = false;
    
            if (filter.column === 'date') {
                const rowDate = row.date ? new Date(row.date) : null;
                const filterDate = filter.value ? new Date(filter.value) : null;
                
                switch (filter.operatorType) {
                    case 'on':
                        // Exact datetime match (date and time)
                        matches = rowDate && filterDate && rowDate.getTime() === filterDate.getTime();
                        break;
                    case 'notOn':
                        // Not exact datetime match (different date or time)
                        matches = rowDate && filterDate && rowDate.getTime() !== filterDate.getTime();
                        break;
                    case 'before':
                        matches = rowDate && filterDate && rowDate < filterDate;
                        break;
                    case 'atOrBefore':
                        matches = rowDate && filterDate && rowDate <= filterDate;
                        break;
                    case 'after':
                        matches = rowDate && filterDate && rowDate > filterDate;
                        break;
                    case 'atOrAfter':
                        matches = rowDate && filterDate && rowDate >= filterDate;
                        break;
                    case 'between':
                        if (Array.isArray(filter.value) && filter.value.length === 2) {
                            const [startDate, endDate] = filter.value.map(date => (date ? new Date(date) : null));
                            matches = rowDate &&
                                    startDate && endDate &&
                                    rowDate >= startDate && rowDate <= endDate;
                        } else {
                            matches = false;
                        }
                        break;
                    case 'isEmpty':
                        matches = !row.date_updated;
                        break;
                    case 'isNotEmpty':
                        matches = !!row.date_updated;
                        break;
                    default:
                        matches = false;
                }
            } else {
                // General filter logic for other columns
                switch (filter.operatorType) {
                    case 'contains':
                        matches = rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'doesNotContain':
                        matches = !rowValue.toLowerCase().includes(filter.value.toLowerCase());
                        break;
                    case 'startsWith':
                        matches = rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
                        break;
                    case 'endsWith':
                        matches = rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
                        break;
                    case 'is':
                        matches = rowValue === filter.value;
                        break;
                    case 'isNot':   
                        matches = rowValue !== filter.value;
                        break;
                    case 'isEmpty':
                        matches = rowValue === '';
                        break;
                    case 'isNotEmpty':
                        matches = rowValue !== '';
                        break;
                    default:
                        matches = false;
                }
            }
    
            return index === 0 ? matches : (filter.operator === 'And' ? acc && matches : acc || matches);
        }, true)
    );

    useEffect(() => {
        setCurrentPage(0);
    }, [filters]);
    const paginatedRows = filteredRows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    
    const columns = [
        {
            field: 'index',
            headerName: 'S.No',
            width: 150,
            flex: 1,
            filterable: true
        },
        {
            field: 'Module',
            headerName: 'Module',
            width: 350,
            flex: 1,
            filterable: true
        },
        {
            field: 'reference',
            headerName: 'Reference',
            width: 350,
            flex: 1,
            filterable: true
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 250,
            flex: 1,
            filterable: true,
        },
        {
            field: 'description',
            headerName: 'Activity',
            width: 300,
            flex: 1,
            filterable: true,
        },
        {
            field: 'Changes',
            headerName: 'Changes',
            width: 300,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <button
                        style={{maxHeight:"30px"}}
                        className='view_btnhist_kn d-flex align-items-center justify-content-center'
                        onClick={() => handleShow(params.row.Changes)}
                        >
                        View
                    </button>
                </div>
            ),
            filterable: true,
        },
        {
            field: 'updatedBy',
            headerName: 'Updated By',
            width: 350,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    <span style={{color:"#C42B7D"}} >{params.row.updatedBy}</span>
                </div>
            ),
            filterable: true
        },
        {
            field: 'date',
            headerName: 'Date',
            width: 350,
            flex: 1,
            filterable: true
        },
    ];
    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';

        // Handle both \n and \r\n (Windows/Mac/Linux line endings)
        const formattedHTML = html
            .replace(/(\r\n|\r|\n){2,}/g, '<br><br>') // double line breaks
            .replace(/(\r\n|\r|\n)/g, '<br>');        // single line breaks

        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center"> 
                    <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> User <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Audit History</span>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="space-between" alignItems="center" className="statusselectbtn my-4">
                        <AdminRoletabs/>
                    </Grid>  
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <Box sx={{ height: 650, width: '100%' }} className="datatable_jobpagi">
                        {isGridVisible && (
                        <Box sx={{ mb: 2 }} className="my-4">
                            {filters.map((filter, index) => (
                                <Box key={index} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    {index > 0 && (
                                        <select  
                                            label="Combine" 
                                            value={filter.operator}
                                            onChange={(e) => handleFilterChange(index, 'operator', e.target.value)}
                                            sx={{ mr: 1, minWidth: 80 }}
                                        >
                                            {combineOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </select>
                                    )}
                                    <TextField
                                        select  
                                        label="Column"
                                        value={filter.column}
                                        onChange={(e) => handleFilterChange(index, 'column', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120 }}
                                    > 
                                        <MenuItem value="updatedBy">Updated By</MenuItem>
                                        <MenuItem value="Module">Module</MenuItem>
                                        <MenuItem value="reference">Reference</MenuItem>
                                        <MenuItem value="Changes">Changes</MenuItem>
                                        <MenuItem value="description">Activity</MenuItem>
                                        <MenuItem value="action">Action</MenuItem>
                                        <MenuItem value="date">Date</MenuItem>
                                    </TextField>
                                    <TextField
                                        select    
                                        label="Operator"
                                        value={filter.operatorType}
                                        onChange={(e) => handleFilterChange(index, 'operatorType', e.target.value)}
                                        sx={{ mr: 1, minWidth: 120 }}
                                    >
                                        {getOperatorOptions(filter.column).map((option) => (
                                            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {filter.operatorType === "isNotEmpty" || filter.operatorType === "isEmpty" ? "" :<>
                                        {filter.column === 'date' ? (
                                            <Box sx={{ display: 'flex', gap: 1 }}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <MobileDateTimePicker
                                                        className='filterrages datemobile_picker'
                                                        label={filter.operatorType === "between" ? "Start Date":"" }
                                                        value={filter.value[0] || null}
                                                        onChange={(newValue) => handleFilterChange(index, 'value', [newValue, filter.value[1]])}
                                                    />
                                                    {filter.operatorType === "between" && 
                                                    <MobileDateTimePicker
                                                        label="End Date"
                                                        className='filterrages datemobile_picker'
                                                        value={filter.value[1] || null}
                                                        onChange={(newValue) => handleFilterChange(index, 'value', [filter.value[0], newValue])}
                                                    />}
                                                </LocalizationProvider>
                                            </Box>
                                        ) : ( 
                                            <input
                                                className='value_inputfilter'
                                                placeholder='Value'
                                                label="Value"  
                                                value={filter.value}
                                                onChange={(e) => handleFilterChange(index, 'value', e.target.value)}
                                            />
                                        )}
                                        </>}
                                    <button className='filterremovebtn' onClick={() => removeFilter(index)}>Remove</button>
                                </Box>  
                            ))}
                            <button className='filteraddbtn' onClick={addFilter}>Add Filter</button>
                        </Box>)}
                        <Grid size={{xs:12}} container justifyContent="space-between">
                        <button className='show_filterbtn' onClick={toggleGrid}>
                            {isGridVisible ?<> Hide Filter <FontAwesomeIcon icon={faFilterCircleXmark} /> </> :<> Show Filter <FontAwesomeIcon icon={faFilter} /> </>}
                        </button>
                        </Grid>
                        <DataGrid
                            style={{minHeight:"200px"}}
                            rows={paginatedRows}
                            columns={columns}  
                            pageSize={pageSize}  
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                        />
                        <div className='d-flex flex-column my-3 pagination_datagrid'>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label className='me-2'>Showing records <b>{filteredRows.length === 0 ? 0 : currentPage * pageSize + 1}–{Math.min((currentPage + 1) * pageSize, filteredRows.length)}</b> out of <b>{filteredRows.length.toLocaleString()}</b></label>
                                </div>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={pageSize}
                                        onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}   
                                    </select>
                                </div>
                            </Grid>

                            <div className="d-flex justify-content-center my-3">
                                <button
                                    className='nexter_btns'
                                    variant="contained"
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                    disabled={currentPage === 0}
                                >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>

                                {/* Page number buttons */}
                                {filteredRows.length > 0 && (
                                    <div className="d-flex align-items-center mx-2">
                                        {(() => {
                                        const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
                                        const pages = [];

                                        const start = Math.max(1, currentPage + 1 - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 1 + 2);

                                        // Always show first page
                                        pages.push(
                                            <button
                                            key={1}
                                            className={`page-btn ${currentPage === 0 ? 'active' : ''}`}
                                            onClick={() => setCurrentPage(0)}
                                            >
                                            1
                                            </button>
                                        );

                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis" className="px-1">...</span>);
                                        }

                                        for (let i = start; i <= end; i++) {
                                            if (i !== 1 && i !== totalPages) {
                                            pages.push(
                                                <button
                                                key={i}
                                                className={`page-btn ${currentPage === i - 1 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(i - 1)}
                                                >
                                                {i}
                                                </button>
                                            );
                                            }
                                        }

                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis" className="px-1">...</span>);
                                        }

                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                className={`page-btn ${currentPage === totalPages - 1 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(totalPages - 1)}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }

                                        return pages;
                                        })()}
                                    </div>
                                )}
 
                                <button  
                                    className='nexter_btns'
                                    variant="contained"
                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredRows.length / pageSize) - 1))}
                                    disabled={currentPage >= Math.ceil(filteredRows.length / pageSize) - 1}
                                >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        </div>
                    </Box>
                </>}
            </Grid>
            <Modal size='lg' centered show={show} onHide={handleClose3}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='mb-3'><div className='w-100' style={{wordBreak:"break-word"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(modalData) }} /></Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default UserAuditHistory
